<template>
  <div>
    <v-footer v-if="productData" class="footer-up" color="#707181" padless>
      <v-row justify="center" no-gutters>
        <v-btn color="white" text rounded class="my-0 col-4 footer-text">
          <a
            v-bind:href="pdfUrl ? pdfUrl : null"
            v-bind:download="pdfUrl ? 'General Terms.pdf' : null"
            @click="openPDF"
            >General Terms</a
          >
        </v-btn>
        <v-btn color="white" text rounded class="my-0 col-4 footer-text">
          <a
            v-if="env === 'production'"
            href="https://expar.si/politika-zasebnosti/"
            target="_blank"
            class="text-muted"
            >Privacy Policy</a
          >
          <a
            v-else
            href="https://demo.expar.si/politika-zasebnosti/"
            target="_blank"
            class="text-muted"
            >Privacy Policy</a
          >
        </v-btn>
        <v-col
          class="footer-down lighten-2 py-4 text-center white--text"
          cols="12"
        >
          {{ new Date().getFullYear() }} |
          <a target="_blank" :href="`${productData.clientWebsite}`">{{
            productData.clientName
          }}</a>
        </v-col>
      </v-row>
    </v-footer>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    productData: null,
    errored: false,
    loading: true,
    pdfUrl: null,
    env: ''
  }),
  mounted() {
    this.env = process.env.NODE_ENV
    axios
      .get(
        this.isExperienceFooter
          ? `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/experience/${this.$route.params.experienceUUID}`
          : `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/product/${this.$route.params.productUUID}`
      )
      .then(response => {
        this.productData = response.data
        this.fetchPDF()
        localStorage.setItem('productData', JSON.stringify(this.productData))
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
  },
  methods: {
    async fetchPDF() {
      try {
        if (this.productData.clientTC) {
          if (this.isPDFUrl(this.productData.clientTC)) {
            const response = await axios.get(
              `${process.env.VUE_APP_API_URL}/client/tc/download?url=${this.productData.clientTC}`,
              {
                responseType: 'blob'
              }
            )
            const pdfBlob = new Blob([response.data], {
              type: 'application/pdf'
            })
            this.pdfUrl = URL.createObjectURL(pdfBlob)
          }
        }
      } catch (error) {
        console.error('Error fetching PDF:', error)
      }
    },
    async openPDF() {
      try {
        if (!this.pdfUrl && this.productData.clientTC) {
          window.open(this.productData.clientTC, '_blank')
        }
      } catch (error) {
        console.error('Error downloading PDF:', error)
      }
    },
    isPDFUrl(url) {
      const filename = url.split('/').pop()
      return filename.toLowerCase().endsWith('.pdf')
    }
  },
  props: {
    isExperienceFooter: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-text {
  font-size: 0.8em;
  font-weight: 100;
  text-transform: lowercase;
}

.footer-up {
  background-color: var(bg-superLight);
}
.footer-down {
  // background-color: var(--bg);
  margin-bottom: 55px;
}
a {
  color: var(--bright) !important;
}
a:hover {
  color: var(--primary);
}
</style>
